"use client"

import { Button } from "@/components/ui/button"
import { useLanguage } from "@/lib/i18n/language-provider"
import { Language } from "@/lib/i18n/translations"
import { Languages } from "lucide-react"

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage()
  
  const toggleLanguage = () => {
    setLanguage(language === "fr" ? "en" : "fr")
  }

  return (
    <Button 
      variant="outline" 
      size="sm" 
      onClick={toggleLanguage}
      className="gap-2"
    >
      <Languages className="w-4 h-4" />
      <span className="text-xs font-semibold">{language === "en" ? "EN" : "FR"}</span>
    </Button>
  )
} 